export const CHECK_REWARDS_ROUTE = '/check-reward';
export const CONFIRM_REGISTER_ROUTE = '/confirm-register';
export const RESET_PASSWORD_ROUTE = '/reset-password';
export const SHARE_PROMO_CODE_ROUTE = '/pobierz-aplikacje';
export const EMPTY_ROUTE = '/404';
export const SOCIAL_AUTH_CALLBACK_ROUTE = '/callback';
